<template>
  <div>
    <b-tabs lazy>
      <b-tab title="Search Engine Configuration">
        <SearchEngineConfigurationComponent
          :negativeMediaEdit="negativeMediaEdit"
          :categoriesIndex="tabIndex"
          :negativeMediaTab="true"
          :searchPage="searchPage"
        />
      </b-tab>
      <b-tab title="Search Text">
        <SearchTextComponent
          :negativeMediaEdit="negativeMediaEdit"
          :categoriesIndex="tabIndex"
          :negativeMediaTab="true"
          :searchPage="searchPage"
        />
      </b-tab>
      <b-tab title="Keywords">
        <KeywordComponent
          :negativeMediaEdit="negativeMediaEdit"
          :categoriesIndex="tabIndex"
          :negativeMediaTab="true"
          :searchPage="searchPage"
          :priConfigrationKeywordsData="priConfigrationKeywordsData"
          :priConfigrationExcludeKeywordsData="priConfigrationExcludeKeywordsData"
        />
      </b-tab>
      <b-tab title="Stopwords">
        <StopwordsComponent
          :negativeMediaEdit="negativeMediaEdit"
          :categoriesIndex="tabIndex"
          :negativeMediaTab="true"
          :searchPage="searchPage"
          :priConfigrationStopWordsData="priConfigrationStopWordsData"
        />
      </b-tab>
      <b-tab title="Natural Language Processing">
        <NaturalLanguageProcessingComponent
          :negativeMediaEdit="negativeMediaEdit"
          :categoriesIndex="tabIndex"
          :negativeMediaTab="true"
          :searchPage="searchPage"
        />
      </b-tab>
      <b-tab title="Scoring">
        <ScoringComponent
          :negativeMediaEdit="negativeMediaEdit"
          :categoriesIndex="tabIndex"
          :negativeMediaTab="true"
          :searchPage="searchPage"
        />
      </b-tab>
      <b-tab title="Filtering">
        <FilteringComponent
          :negativeMediaEdit="negativeMediaEdit"
          :categoriesIndex="tabIndex"
          :negativeMediaTab="true"
          :searchPage="searchPage"
        />
      </b-tab>
    </b-tabs>
  </div>
</template>

<script>
import KeywordComponent from "./negativeMediaComponent/keywordsComponent.vue";
import StopwordsComponent from "./negativeMediaComponent/stopwordsComponent.vue";
import NaturalLanguageProcessingComponent from "./negativeMediaComponent/naturalLanguageProcessingComponent.vue";
import SearchEngineConfigurationComponent from "./negativeMediaComponent/searchEngineConfigurationComponent.vue";
import ScoringComponent from "./negativeMediaComponent/scoringComponent.vue";
import SearchTextComponent from "./negativeMediaComponent/searchTextComponent.vue";
import FilteringComponent from "./negativeMediaComponent/filteringComponent.vue";
export default {
  name: "NegativeMediaComponent",
  components: {
    KeywordComponent,
    StopwordsComponent,
    NaturalLanguageProcessingComponent,
    SearchEngineConfigurationComponent,
    ScoringComponent,
    SearchTextComponent,
    FilteringComponent
  },
  data() {
    return {
      selectedLanguage: "lang_en"
    };
  },
  mounted() {
    // // console.log(this.$store.state.priConfigrationforms.negativeMedia.categories);
  },
  methods: {},
  props: {
    tabIndex: Number,
    negativeMediaEdit: Boolean,
    searchPage: Boolean,
    priConfigrationKeywordsData: Array,
    priConfigrationExcludeKeywordsData: Array,
    priConfigrationStopWordsData: Array
  }
};
</script>
